// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"141":"history","489":"prayers","655":"zikr","721":"zikr-app","884":"admin","933":"auth"}[chunkId] || chunkId) + "." + {"141":"180069d1","177":"aaa97f9f","474":"8baefeb8","489":"a21680b7","655":"781cd678","721":"77249d72","749":"c21fa777","884":"e051ef41","933":"6f1772dd"}[chunkId] + ".js";
};